import { useState } from 'react';
import * as _ from 'underscore';

import { Messages } from '../../../../../codegen/Localize';
import { SiteSwitchService } from '../../../../../ts/siteManagement/services/SiteSwitchService';
import { SiteNameAndIdSectionProps } from './SiteNameAndIdSection';

export function calculateUrlFromUrlName(urlName: string) {
  return window.location.href.replace(window.location.hash.substring(1), '') +
    SiteSwitchService.getSitePathFragment(urlName);
}

export function calculateEncodedUrlFromUrlName(urlName: string) {
  return () => window.location.href.replace(window.location.hash.substring(1), '') +
    SiteSwitchService.getEncodedSitePathFragment(urlName);
}

export const calculateUrlNameFromSiteName = (siteName: string) =>
  _.isString(siteName) ? siteName.replace(SiteIdValidRegExp.InvalidFind, '') : '';

export function useShouldCopySiteNameToUrl(props: SiteNameAndIdSectionProps) {
  const [shouldCopySiteNameToUrl] = useState(!props.isDefaultSite &&
    calculateUrlNameFromSiteName(props.settings.name) === props.settings.urlName);

  return shouldCopySiteNameToUrl;
}

export const SiteIdValidator = (v: string) => SiteIdValidRegExp.InvalidTest.test(v)
  ? undefined
  : Messages.siteIDInvalid();

export class SiteIdValidRegExp {
  private static Chars: string = 'A-Za-z0-9\-\_';
  public static InvalidFind: RegExp = new RegExp('[^' + SiteIdValidRegExp.Chars + ']', 'g');
  public static InvalidTest: RegExp = new RegExp('^[' + SiteIdValidRegExp.Chars + ']+$');
}
